'use strict';

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ConnectionStatusMonitorDirective=class ConnectionStatusMonitorDirective extends BaseControllerBackedDirective{
get optionalObjectBindings(){return['enabled']}

get controller(){return ConnectionStatusMonitorDirectiveController}};


const ControllerDefaults={
enabled:!0,
_initiallyConnected:!1,
_toast:null,
_showingDisconnectionToast:!1,
_showingReconnectionToast:!1};let


ConnectionStatusMonitorDirectiveController=class ConnectionStatusMonitorDirectiveController{
constructor($scope,$timeout,$mdToast,socketService){
this._$scope=$scope;
this._$timeout=$timeout;
this._$mdToast=$mdToast;
this._socketService=socketService;

_.defaults(this,ControllerDefaults);

this._reconnectedToast=$mdToast.
simple().
textContent('Reconnected!').
hideDelay(1000).
position('bottom left');

this._disconnectedToast=$mdToast.
simple().
textContent('Disconnected from server, attempting to reconnect...').
hideDelay(0).
position('bottom left');

const debouncedUpdateConnectionStatus=_.debounce(
()=>this._socketService.isConnected?
this._displayReconnectedToast():
this._displayDisconnectionToast(),1000);

this._$timeout(()=>{

this._$scope.$watch('controller._socketService.isConnected',(isConnected,wasConnected)=>{
if(!this.enabled){
return;
}

if(!this._initiallyConnected){
this._initiallyConnected=isConnected;
if(isConnected){

return;
}
}

if(wasConnected&&isConnected===wasConnected){
return;
}

debouncedUpdateConnectionStatus();
});
},2000);
}

async _displayDisconnectionToast(){
if(this._showingDisconnectionToast){
return;
}

this._showingDisconnectionToast=!0;
await _performActionWithCleanupAndEatErrors(
()=>this._$mdToast.show(this._disconnectedToast),
()=>this._showingDisconnectionToast=!1);
}

async _displayReconnectedToast(){
if(this._showingReconnectionToast){
return;
}

this._showingReconnectionToast=!0;

if(this._showingDisconnectionToast){
await _performActionWithCleanupAndEatErrors(
()=>this._$mdToast.hide(this._disconnectedToast),
()=>this._showingDisconnectionToast=!1);
}

await _performActionWithCleanupAndEatErrors(
()=>this._$mdToast.show(this._reconnectedToast),
()=>this._showingReconnectionToast=!1);
}};




async function _performActionWithCleanupAndEatErrors(asyncToastAction,cleanup){
try{
await asyncToastAction();
}catch(err){

}finally{
cleanup();
}
}

module.exports=ConnectionStatusMonitorDirective;
//# sourceMappingURL=connectionStatusMonitorDirective.js.map
